var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cursor-pointer",on:{"click":function($event){return _vm.$emit('open-gallery', _vm.index)}}},[(_vm.visible)?_c('img',{staticClass:"impression-image",attrs:{"src":_vm.impression.url,"alt":_vm.impression.alt}}):_vm._e()])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0036eb4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Impression.vue
// module id = F9XP
// module chunks = 0